import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/20/thumb-landscape.jpg"

const Post20 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          「シーンやスタイルを問わず、いつでも使えるバッグがいい！」そんな風に思うことはないですか？1つのバッグでオン／オフのどちらでも使えたら便利ですよね。ご紹介するフェンディのバッグは、シンプルで使いやすく季節も問いません。いろんなコーデと相性がいい、何にでも合う万能バッグがあれば、いつものコーデがもっと素敵に、さらに新しいスタイルにだって挑戦できちゃうかも！では、そんなフェンディの万能バッグをのぞいてみましょう。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ピーカブー</h2>
          <p>FENDI／フェンディのアイコンバックといえばピーカブー！2009年にコレクションデビューして以来、変わらぬ人気で愛され続けているバッグ。4つのサイズ展開をご紹介します！</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/20/1.jpg" alt="" />
        </figure>
        <div className="text-max-width">
            <h2>1.アクセサリー気分で持ちたいマイクロ</h2>
            <p>4サイズの中でも一番小さい「マイクロ」は、細めのストラップ付き。斜めがけにしたり、大きめバッグのチャームにしたり、アクセサリー気分で持つのが正解！手のひらサイズながら、内側には仕切りがありスマホやリップもきれいに収納できちゃいます。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/20/2.jpg" alt="" />
        </figure>
        <span className="text-center">15x10x5cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>2.フォーマルな場面でも使えるミニ</h2>
          <p>ちょっといいレストランでのお食事やフォーマルな場面でも活躍する上品なサイズです。とはいえ、斜めがけすればカジュアルコーデにも好相性。まさに万能！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/20/3.jpg" alt="" />
        </figure>        
        <span className="text-center">23x19x11cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>3.定番人気はやっぱりレギュラー</h2>
          <p>適度な収納力で通勤にも使えデイリーユースはもちろん、オシャレしてお出掛けするディナーにも◎内部は中央が仕切られているので、荷物もキチンと整理して収納できます。</p>
        </div>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/20/4.jpg" alt="" />
        </figure>
        <span className="text-center">34x23x10cm(幅x高さxマチ)</span> 
        <div className="text-max-width">
          <h2>4.ビッグシルエットがかわいいラージ</h2>
          <p>A4サイズの書類やiPadもスッポリ収まる1番大きなラージはビジネスシーンにも大活躍！斜めがけするとビッグシルエット効果でモードな印象に変わります。ガバっと大きく開くから使い勝手も良好！</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/20/5.jpg" alt="" />
        </figure>
        <span className="text-center">40x30x15cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>バイザウェイ</h2>
          <p>2014年に発表されたバイザウェイは、ボストンバッグを小さくしたようなシルエット。さまざま持ち方ができることが、このバッグの最大の特徴です。基本のハンドバッグやストラップを付けてショルダーバッグのほかに、ハンドルがボディに沿うようなデザインのためクラッチバッグとしても楽しめます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/20/6.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/20/7.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">20x13x9cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>いま選びたいオススメカラー</h2>
          <p>ブラックは間違いない定番カラー。迷ったらブラックを選ぶのが正解です！</p>
        </div>        
        <figure className="img-small">
        <StaticImage src="../../images/posts/20/8.jpg" alt="" />
        </figure>      
        <span className="text-center">28x16x13cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <p>こっくりとした色味が可愛いブラウン。FENDIのロゴが大きくあしらわれた「サンシャイン」シリーズはカジュアルにぴったり。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/20/9a.jpg" alt="" />
        </figure>
        <span className="text-center">28x18x13cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <p>ボディ部分の深いグリーンにジップ部分のフリル装飾がアクセント。大人の遊び心がつまった一品です。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/20/10a.jpg" alt="" />
        </figure>
        <span className="text-center">27x17x13cm(幅x高さxマチ)</span>      
        <div className="text-max-width">
          <h2>トゥージュール</h2>
          <p>トゥージュールは2012年に登場したエレガントなハンドバッグ。高品質なカーフレザーにフロントトップのメタルプレートがポイントです。ボックス型のフォルムがスッキリとした印象で、洗練された女性を演出してくれます。また、カジュアルなスタイルに合わせれば、手抜き感ゼロに早変わり！</p>
        </div>
        <div className="text-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/20/11a.jpg" alt="" />
          </figure>              
          <figure className="img-small">
            <StaticImage src="../../images/posts/20/12a.jpg" alt="" />
          </figure>
        </div>           
        <span className="text-center">35x27x14cm(幅x高さxマチ)</span>
        <figure className="img-small">
          <StaticImage src="../../images/posts/20/12b.jpg" alt="" />
        </figure>                        
        <span className="text-center">27x20x13cm(幅x高さxマチ)</span>
        <div className="text-two-cloumn">
          <h2>万能バッグで<br className="pc"></br>ファッションを満喫</h2>
          <p>１つのバッグで、いろんなシーン、いろんなスタイルに合わせられたら…、想像するとなんだかワクワクしてきませんか？「これさえあれば安心！」そんなバッグが手元にあったら、とても心強いものです。いろんなバッグを試して、とことんファッションを楽しみましょう！</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post20

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 20}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
